import * as React from "react";
import type { SVGProps } from "react";
const SvgTarget01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M21.6 12a9.6 9.6 0 0 1-9.6 9.6m9.6-9.6A9.6 9.6 0 0 0 12 2.4m9.6 9.6H18m-6 9.6A9.6 9.6 0 0 1 2.4 12m9.6 9.6V18m-9.6-6A9.6 9.6 0 0 1 12 2.4M2.4 12H6m6-9.6V6"
    />
  </svg>
);
export default SvgTarget01;
